module.exports = __webpack_public_path__ + "img/visa.cd97a1d.svg";